import { NETWORK_NAV_ENTRIES } from '@/app/navigation-context/nav/network-nav.config.js';
import { PLACE_NAV_ENTRIES } from '@/app/navigation-context/nav/place-nav.config.js';
import { PLATFORM_NAV_ENTRIES } from '@/app/navigation-context/nav/platform-nav.config.js';
import { TENANT_NAV_ENTRIES } from '@/app/navigation-context/nav/tenant-nav.config.js';
import type { NavigationLevel } from '@/app/navigation-context/types.js';
import type { ShellNavEntry } from '@/shared/shell/nav.types.js';

export function resolveNavEntries(level: NavigationLevel): readonly ShellNavEntry[] {
  switch (level) {
    case 'place':
      return PLACE_NAV_ENTRIES;
    case 'tenant':
      return TENANT_NAV_ENTRIES;
    case 'network':
      return NETWORK_NAV_ENTRIES;
    case 'platform':
      return PLATFORM_NAV_ENTRIES;
    default: {
      const _exhaustive: never = level;
      return _exhaustive;
    }
  }
}
